/**
 * Getter Dependencies
 */
import { get } from 'lodash'

/**
 * Authentication Status
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const isLoggedIn = state => state.isLoggedIn

/**
 * Determine whether the application is loading
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const userLoading = state => state.pending

/**
 * Retrieve the user profile
 *
 * @param  {Object} state
 * @return {Object}
 */
const userProfile = state => state.profile

/**
 * Return the user's company name
 *
 * @param  {Object} state
 * @return {String}
 */
const userFullName = state => {
    let name = ''
    name += state.profile.data.first_name || ''
    name += state.profile.data.last_name
        ? ' ' + state.profile.data.last_name
        : ''

    return name
}

/**
 * Get the user's initials derived from the full name
 *
 * @param  {Object} state
 * @return {String}
 */
const userInitials = (state, getters) => {
    let initials = getters.userFullName.match(/\b\w/g) || []
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase()

    return initials
}

/**
 * Return the user's full company name
 *
 * @param  {Object} state
 * @return {String}
 */
const userCompanyName = state => get(state, 'profile.data.company.name', null)

/**
 * Determine whether the profile has been loaded from the API
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const userProfileLoaded = state => get(state, 'profile.loaded', null)

/**
 * Return the user's admin status
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const isCompanyAdmin = state => get(state, 'profile.data.is_company_admin', false)

/**
 * Return the user's super admin status
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const isSuperAdmin = state => get(state, 'profile.data.is_company_superuser', false)

/**
 * Return the user's preferences from the user state
 *
 * @param  {Object} state
 * @return {Object}
 */
const userPreferences = state => get(state, 'profile.data.preferences', {})

export default {
    isLoggedIn,
    userLoading,
    userProfile,
    isSuperAdmin,
    userFullName,
    userInitials,
    isCompanyAdmin,
    userPreferences,
    userCompanyName,
    userProfileLoaded
}



// WEBPACK FOOTER //
// ./src/state/modules/user/getters.js